import React, {useEffect} from 'react';
import {TextField} from '@mui/material';
import passwordResetModel from './models/passwordResetModel'
import {Field, useFormikContext} from "formik";
import { styles } from '../../theme/theme';

const {formField: {password, confirmPassword}} = passwordResetModel;

interface OwnProps {
  apiError?: string
}

const PasswordResetFields = (props: OwnProps) => {
    const {apiError=''} = props
    const {errors, setErrors, touched} = useFormikContext<any>();

    useEffect(() => {
        setErrors({[confirmPassword.name]: apiError})
    }, [apiError, setErrors])

    return (
        <React.Fragment>

            <Field
            as={TextField}
            variant={styles.textFieldVariant}
            fullWidth
            data-cy={password.name}
            name={password.name}
            label={password.label}
            required={password.required}
            inputProps={{required: false}}
            type={password.inputType}
            error={Boolean(errors[password.name])}
            helperText={errors[password.name] ? errors[password.name] : ''}
            />

            <Field
            as={TextField}
            variant={styles.textFieldVariant}
            fullWidth
            data-cy={confirmPassword.name}
            name={confirmPassword.name}
            label={confirmPassword.label}
            required={confirmPassword.required}
            inputProps={{required: false}}
            type={confirmPassword.inputType}
            error={touched[confirmPassword.name] && Boolean(errors[confirmPassword.name])}
            helperText={touched[confirmPassword.name] && errors[confirmPassword.name] ? errors[confirmPassword.name] : ''}
            />
        </React.Fragment>
    )
}

export default PasswordResetFields
